import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Modal from '@material-ui/core/Modal'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { changePassword } from '../../../../redux/slices/auth'
import { makeErrorToast } from '../../../../utils/makeToast'
import LoadingButton from '../../Button/LoadingButton'

const useStyles = makeStyles((theme) => ({
	saveModal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	saveModalContent: {
		borderRadius: '10px',
		backgroundColor: theme.palette.background.paper,
		width: '50%',
	},
	formContainer: {
		padding: theme.spacing(3),
		'& h5': {
			display: 'flex',
			justifyContent: 'center',
		},
	},
	buttonsContainer: {
		flexGrow: 1,
		marginLeft: 'auto',
	},
	button: {
		padding: theme.spacing(1),
	},
	errorMessage: {
		color: 'red',
		padding: 0,
		'&:before': {
			display: 'inline',
			content: '"⚠"',
		},
	},
	fields: {
		display: 'flex',
		'& div': {
			marginRight: '1rem',
		},
	},
}))

function ChangePasswordModal({ isOpen, closeChangePasswordModal }) {
	const classes = useStyles()
	const dispatch = useDispatch()
	const { register, handleSubmit, errors, getValues } = useForm({
		mode: 'all',
	})
	const { t } = useTranslation()
	const { t: tSettings } = useTranslation('settings')
	const { t: tNewPassword } = useTranslation('newPassword')
	const { t: tClientFormModal } = useTranslation('ClientFormModal')

	const ChangePasswordSubmit = ({
		currentPassword,
		newPassword,
		retypeNewPassword,
	}) => {
		if (newPassword === retypeNewPassword) {
			dispatch(changePassword({ currentPassword, newPassword }))
		} else {
			makeErrorToast('The passwords do not match!')
		}
		closeChangePasswordModal()
	}

	const handleCloseModal = () => {
		closeChangePasswordModal()
	}
	return (
		<Modal
			aria-labelledby="Change Password Modal"
			aria-describedby="Change Password"
			open={isOpen}
			className={classes.saveModal}
			onClose={handleCloseModal}
		>
			<div className={classes.saveModalContent}>
				<Grid container>
					<Paper className={classes.formContainer}>
						<form
							onSubmit={handleSubmit(ChangePasswordSubmit)}
							noValidate
						>
							<Grid item container spacing={2}>
								<Grid item xs={12}>
									<Typography variant="h5">
										{tSettings('changePassword')}
									</Typography>
									{/* <Typography variant='h4'>Change Password</Typography> */}
								</Grid>
								<Grid item xs={12}>
									<TextField
										variant="outlined"
										margin="normal"
										inputRef={register({ required: true })}
										required
										fullWidth
										name="currentPassword"
										label={tNewPassword('currentPwd')}
										type="password"
										id="currentPassword"
										autoComplete="current-password"
									/>
									{errors.currentPassword && (
										<p className={classes.errorMessage}>
											{tNewPassword(
												'errorMsg.currentPasswordRequired'
											)}
										</p>
									)}
								</Grid>
								<Grid item xs={12}>
									<TextField
										variant="outlined"
										margin="normal"
										inputRef={register({
											required: true,
											minLength: 8,
										})}
										required
										fullWidth
										name="newPassword"
										label={tNewPassword('newPwd')}
										type="password"
										id="newPassword"
										autoComplete="current-password"
									/>
									{errors.newPassword?.type ===
										'required' && (
										<p className={classes.errorMessage}>
											{tNewPassword(
												'errorMsg.pwdRequired'
											)}
										</p>
									)}
									{errors.newPassword?.type ===
										'minLength' && (
										<p className={classes.errorMessage}>
											{tNewPassword(
												'errorMsg.pwdMinLength'
											)}
										</p>
									)}
								</Grid>
								<Grid item xs={12}>
									<TextField
										variant="outlined"
										margin="normal"
										inputRef={register({
											validate: (value) =>
												value ===
												getValues('newPassword'),
										})}
										required
										fullWidth
										name="retypeNewPassword"
										label={tNewPassword('retypePwd')}
										type="password"
										id="retypeNewPassword"
										autoComplete="current-password"
									/>
									{errors.retypeNewPassword && (
										<p className={classes.errorMessage}>
											{tNewPassword(
												'errorMsg.pwdNotMatch'
											)}
										</p>
									)}
								</Grid>
								<Grid
									item
									xs={12}
									className={classes.buttonsContainer}
								>
									<span className={classes.button}>
										<LoadingButton
											type="submit"
											variant="contained"
											color="primary"
											className={classes.button}
											size="large"
										>
											{tClientFormModal('save')}
										</LoadingButton>
									</span>
									<span className={classes.button}>
										<Button
											variant="contained"
											color="secondary"
											className={classes.button}
											onClick={handleCloseModal}
											size="large"
										>
											{tClientFormModal('cancel')}
										</Button>
									</span>
								</Grid>
							</Grid>
						</form>
					</Paper>
				</Grid>
			</div>
		</Modal>
	)
}

export default ChangePasswordModal
